import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { EllipsisWithLineClamp } from '@simplywallst/ui-core';
import { Column } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';

export const TileLink = styled(RouterLink)`
  display: block;
`;

interface ContainerProps {
  image?: string;
}

export const TileColumn = styled(Column)`
  padding: 0 ${({ theme }) => theme.x2spacePx}px;
  ${media.mdDown`
  padding: 0 ${({ theme }) => theme.x1spacePx}px;
  `};
`;

export const Container = styled('div')<ContainerProps>`
  position: relative;
  z-index: 0;
  overflow: hidden;
`;

export const CopyContainer = styled.div`
  max-height: 152px;
  ${media.mdDown`
    max-height: 160px;
  `};
`;

export const Title = styled('h2')`
  ${({ theme }) => theme.typography.smallStrong}
  text-align: center;
  margin: 0;
  padding: 0 ${({ theme }) => theme.x2spacePx}px;
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  ${EllipsisWithLineClamp(2)}
`;

export const Description = styled.p`
  text-align: center;
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  margin: 0;
  padding: 0 ${({ theme }) => theme.x2spacePx}px;
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  margin-bottom: ${({ theme }) => theme.x4spacePx}px;
  ${EllipsisWithLineClamp(3)}
`;

interface CoverContainerProps {
  padded?: boolean;
}

export const CoverContainer = styled('div')<CoverContainerProps>`
  height: 160px;
  padding: ${({ padded, theme }) => (padded ? theme.x2spacePx : 0)}px;
  ${media.smDown`
    height: 100px;
  `};
`;

export type ObjectFitValue = 'cover' | 'contain' | 'fill';
interface CoverImageProps {
  objectFit?: ObjectFitValue;
}

export const CoverImage = styled('img')<CoverImageProps>`
  object-fit: ${({ objectFit }) => objectFit || 'cover'};
  width: 100%;
  height: 100%;
  transition: all 0.4s ease-out;
  border-radius: 8px;
`;
